import AddButton from '../../core/AddButton';
import SearchSelect from '../../core/SearchSelect';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../../core/CancelButton';
import { globalStyles as styles } from '../../core/style/gstheme';
import { Typography } from '@material-ui/core';

class FindTaxonomyProjectDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
        this.cancellable = null;
    }

    handleClickOpen = () => this.setState({ open: true });

    computeSearch = (value, lang) => {
        let fullSearch =
        {
            search: [
                {
                    predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                    value: "https://grafsync.graphifi.com/schema/gs/TaxonomyProject"
                },
                {
                  predicate: "https://grafsync.graphifi.com/schema/gs/isVersionOfProject",
                  invert: true
                },
                {
                    predicate: "http://purl.org/dc/terms/title",
                    value: value,
                    isExactMatch: false
                }
            ],
            exclude: this.props.exclude,
            language: lang,
            sort: ["http://purl.org/dc/terms/title"],
            searchMode: "Compliant",
            predicates: ["http://purl.org/dc/terms/title"]
        };
        return fullSearch;
    };

    addProject = (id) => {
        this.props.onAddProject(id);
        this.exitAddProject();
    };

    exitAddProject = () => this.setState({ open: false });

    render() {

        const { classes, defaultLang, exclude } = this.props;

        return (
            <React.Fragment>
                <AddButton dataTest="add-project" onClick={() => this.handleClickOpen()} title="Add project" />
                <Dialog
                    data-test="add-taxonomy-project-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.smallDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open} onClose={this.exitFindResource} aria-labelledby="find-project-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="find-project-dialog-title">Add Project</DialogTitle>
                    <DialogContent style={{ height: '400px', overflow: 'visible' }}>
                        <SearchSelect
                            dataTest="find-project"
                            focus={true}
                            sortProp="title"
                            wrapped={true}
                            exclude={exclude}
                            search={(value, lang) => this.computeSearch(value, lang)}
                            listDisplay={(result, lang) => {
                                if (result.title[lang]) {
                                    return <div>
                                        <Typography data-test="result-label" variant="body2">
                                            <Tooltip placement="left" title={result.id}>
                                                <span>
                                                    {result.title[lang]}
                                                </span>
                                            </Tooltip>
                                        </Typography>
                                    </div>;
                                }
                                else {
                                    return <Typography data-test="result-label" variant="body2">No title available ({result.id})</Typography>;
                                }
                            }}
                            isClickableResult={(result) => {
                                if (result.invalid) return false;
                                return true;
                            }}
                            title="Filter projects"
                            lang={defaultLang}
                            chosen={this.addProject} />
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddProject} />
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

FindTaxonomyProjectDialog.defaultProps = {
    exclude: []
};

FindTaxonomyProjectDialog.propTypes = {
    classes: PropTypes.object,
    project: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    exclude: PropTypes.array,
    defaultLang: PropTypes.string.isRequired,
    onAddProject: PropTypes.func.isRequired
};

export default withStyles(styles)(FindTaxonomyProjectDialog);